"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SearchInterfaceProvider_1 = require("../../utils/SearchInterfaceProvider");
var ElementWithContextInitializer_1 = require("./ElementWithContextInitializer");
var coveo_search_ui_1 = require("coveo-search-ui");
var SearchboxInitializer = (function () {
    function SearchboxInitializer() {
        this.searchInterfacesProvider = new SearchInterfaceProvider_1.SearchInterfacesProvider();
    }
    SearchboxInitializer.prototype.initSearchboxIfStandalone = function (searchboxElement, searchPageUri, options) {
        var _this = this;
        var searchInterfaces = this.searchInterfacesProvider.getSearchInterfacesInPage(["Recommendation", "SearchInterface"]);
        return this.waitForSearchInterfacesInitialization(searchInterfaces).then(function () {
            if (_this.searchboxElementIsNotInitialized(searchboxElement)) {
                if (!!searchPageUri) {
                    ElementWithContextInitializer_1.ElementWithContextInitializer.initializeContextWithinElement(searchboxElement);
                    // coveo-search-ui doesn't like an initSearchbox directly on the searchbox.
                    coveo_search_ui_1.initSearchbox(searchboxElement.parentElement, searchPageUri, options);
                }
                else {
                    console.warn("The search box is not included in any search interface and the \"searchPageUri\" parameters is not specified. Consider using a Global Searchbox instead.", searchboxElement);
                }
            }
        });
    };
    SearchboxInitializer.prototype.searchboxElementIsNotInitialized = function (searchBoxElement) {
        return typeof (coveo_search_ui_1.get(searchBoxElement, Coveo.Searchbox)) === "undefined";
    };
    SearchboxInitializer.prototype.waitForSearchInterfacesInitialization = function (searchInterfaces) {
        return Promise.all(this.getAllSearchInterfacesAfterComponentInitialization(searchInterfaces))
            .then(function () { });
    };
    SearchboxInitializer.prototype.getAllSearchInterfacesAfterComponentInitialization = function (searchInterfaces) {
        var _this = this;
        return searchInterfaces.map(function (searchInterface) { return coveo_search_ui_1.$$(searchInterface); })
            .map(function (searchInterface) { return _this.waitForSearchInterfaceInitialization(searchInterface); });
    };
    SearchboxInitializer.prototype.waitForSearchInterfaceInitialization = function (searchInterface) {
        return new Promise(function (resolve, reject) {
            searchInterface.on(coveo_search_ui_1.InitializationEvents.afterComponentsInitialization, function () { return resolve(); });
        });
    };
    return SearchboxInitializer;
}());
exports.SearchboxInitializer = SearchboxInitializer;



//////////////////
// WEBPACK FOOTER
// ./src/base/initialization/SearchboxInitializer.ts
// module id = 32
// module chunks = 13 14